const SystemStatus = {
  state: {
    systemStatus: null, // 'online'
    systemStatusInfoList: [
      {
        type: 'lz-status-online',
        status: 'online',
        description: 'Online & Generating Gold'
      },
      {
        type: 'lz-status-attention',
        status: 'needs-attention',
        description: 'Needs Attention'
      },
      {
        type: 'lz-status-maintenance',
        status: 'maintenance',
        description: 'Maintenance'
      },
      {
        type: 'lz-status-offline',
        status: 'offline',
        description: 'Offline'
      },
    ]
  },
  getters: {
    systemStatus: state => state.systemStatus,
    systemStatusInfoList: state => state.systemStatusInfoList,
    systemStatusInfo: state => {
      return state.systemStatusInfoList.find(config => config.status === state.systemStatus);
    }
  },
  mutations: {
    setSystemStatus: (state, systemStatus) => state.systemStatus = systemStatus,
    updateSystemStatusInfoList: (state, systemStatusInfoList) => state.systemStatusInfoList = systemStatusInfoList,
  },
}

export {
  SystemStatus
}